import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { UmsService } from './ums.service';
import { ModalpopService } from './modalpop.service';
import { AlertboxComponent } from './alertbox/alertbox.component';

@Injectable({
    providedIn: 'root'
})
export class ReportService {

    constructor(
        private umsService: UmsService,
        private spinner: NgxSpinnerService,
        private modalPopupService: ModalpopService,
    ) { }

    generateHbsReport(filter: any) {
        this.spinner.show();

        this.umsService.SetReportParam(filter).subscribe(
            (res) => {
                this.spinner.hide();

                if (res.status) {
                    this.renderHbsReport(filter);
                } else {
                    this.showError(res.message);
                }
            },
            (ERROR: HttpErrorResponse) => {
                this.spinner.hide();
                this.showError(ERROR.error.message);
            }
        );
    }

    private renderHbsReport(filter: any) {
        const payload = {
            "LoginId": parseInt(sessionStorage.getItem('StudentRGID')) ? parseInt(sessionStorage.getItem('StudentRGID')) : 0,
            "Mode": filter.Mode ? true : false
        };

        this.spinner.show();

        const reportWindow = window.open('', '_blank');

        if (reportWindow) {
            reportWindow.document.write(`
        <html>
          <head>
            <title>Loading Report...</title>
            <style>
              html, body {
                height: 100%;
                margin: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f5f5f5;
                font-family: Arial, sans-serif;
              }
              .loader-wrap {
                text-align: center;
              }
              .spinner {
                width: 50px;
                height: 50px;
                border: 5px solid #ddd;
                border-top: 5px solid #3f51b5;
                border-radius: 50%;
                margin: 0 auto 16px;
                animation: spin 1s linear infinite;
              }
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
              p {
                color: #555;
                font-size: 15px;
              }
            </style>
          </head>
          <body>
            <div class="loader-wrap">
              <div class="spinner"></div>
              <p>Generating your report, please wait...</p>
            </div>
          </body>
        </html>
      `);
            reportWindow.document.close();
        }

        this.umsService.renderHbsReport(payload).subscribe(
            (res: Blob) => {
                this.spinner.hide();

                if (res.type === "application/csv") {
                    if (reportWindow) reportWindow.close();
                    saveAs(res, 'report.csv');
                } else {
                    const blobUrl = URL.createObjectURL(res);
                    if (reportWindow) {
                        reportWindow.location.href = blobUrl;
                    } else {
                        window.open(blobUrl, '_blank');
                    }
                    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
                }
            },
            (error) => {
                this.spinner.hide();
                if (reportWindow) {
                    reportWindow.document.write(`
            <html>
              <body style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:Arial,sans-serif;">
                <p style="color:#c62828;">Failed to load report. Please close this tab and try again.</p>
              </body>
            </html>
          `);
                }
            }
        );
    }

    private showError(message: string) {
        let data = {};
        data['message'] = message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    }
}